import { Box, Button, Grid, Link, Typography } from '@mui/material';
import { useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import ButtonCTAOnboarding from './components/ButtonCTAOnboarding';
import TestimonialsTwoCarousel from './components/TestimonialsCarousel';

export const ConfirmBusinessPhoneNumber = () => {
  const [phoneNumber, setPhoneNumber] = useState<string | undefined>(undefined);

  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#19191C',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          position: 'relative',
        }}
      >
        <Box sx={{ position: 'absolute', top: 32, left: 32 }}>
          <img
            src="/icon/artwork.svg"
            alt=""
            style={{ width: 100, height: 'auto' }}
          />
        </Box>
        <Box
          sx={{
            width: '100%',
            maxWidth: 400,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mt: 8,
          }}
        >
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="h4"
            fontWeight={700}
            fontSize={24}
            mb={1}
            align="center"
            sx={{ width: '100%' }}
          >
            What's your phone number?
          </Typography>
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="subtitle1"
            fontWeight={100}
            mb={5}
            align="center"
            sx={{ width: '100%', lineHeight: '1.7' }}
          >
            We'll send a verification code to this number to confirm your
            identity.
          </Typography>
          <Box sx={{ width: '100%', mb: 3 }}>
            <Typography
              variant="subtitle1"
              sx={{ mb: 1.5, color: '#fff', fontWeight: 400 }}
            >
              Phone number
            </Typography>
            <Box
              sx={{
                '& .PhoneInput': {
                  width: '100%',
                  border: '1px solid #fff',
                  borderRadius: '8px',
                  transition: 'border-color 0.2s',
                  backgroundColor: 'transparent',
                },
                '& .PhoneInputInput': {
                  flex: '1',
                  border: 'none',
                  outline: 'none',
                  height: '48px',
                  paddingLeft: '12px',
                  fontSize: '1rem',
                  color: '#fff',
                  backgroundColor: 'transparent',
                  '::placeholder': {
                    color: '#BDBDBD',
                    opacity: 1,
                  },
                },
                '& .PhoneInputCountry': {
                  display: 'flex',
                  alignItems: 'center',
                  margin: '0 12px',
                },
                '& .PhoneInputCountrySelectArrow': {
                  display: 'none',
                },
              }}
            >
              <PhoneInput
                placeholder="+1 (123) 123-1234"
                value={phoneNumber}
                onChange={setPhoneNumber}
                international
                countryCallingCodeEditable={false}
                defaultCountry="US"
              />
            </Box>
          </Box>

          <ButtonCTAOnboarding
            label="Send verification code"
            onClick={() => {}}
          />
          <Link
            href="#"
            color="#4949C8"
            underline="hover"
            sx={{ fontSize: 16, fontWeight: 400, mt: 3, mb: 1 }}
          >
            Sign up using email
          </Link>
          <Typography variant="body2" mt={4} textAlign="center" color="#fff">
            Already have an account?{' '}
            <Link href="#" color="#4949C8" underline="hover">
              Sign in
            </Link>
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#fafafd',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: 600, textAlign: 'center', mb: 0 }}>
          <Typography
            variant="h5"
            fontFamily="Space Grotesk"
            fontWeight={700}
            color="#4949C8"
            sx={{ mb: 1 }}
          >
            This is what we found about <br /> your business
          </Typography>
          <Typography variant="subtitle1" color="#222" sx={{ mb: 4 }}>
            We automatically pulled this info from your <br /> website.
          </Typography>
        </Box>
        <TestimonialsTwoCarousel />
      </Grid>
    </Grid>
  );
};
